import { render } from "./protocol.vue?vue&type=template&id=304d175c&scoped=true"
import script from "./protocol.vue?vue&type=script&lang=js"
export * from "./protocol.vue?vue&type=script&lang=js"

import "./protocol.vue?vue&type=style&index=0&id=304d175c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304d175c"]])

export default __exports__